function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const React = require('react');

function SvgMagento(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.2c1.5 0 2.9.3 4.2.8 1.3.5 2.4 1.3 3.4 2.3s1.8 2.1 2.3 3.4c.6 1.3.8 2.7.8 4.2s-.3 2.9-.8 4.2-1.3 2.4-2.3 3.4-2.1 1.8-3.4 2.3c-1.3.6-2.7.8-4.2.8s-2.9-.3-4.2-.8-2.4-1.3-3.4-2.3-1.8-2.1-2.3-3.4c-.6-1.3-.8-2.7-.8-4.2s.3-2.9.8-4.2 1.3-2.4 2.3-3.4S6.5 2.5 7.8 2s2.7-.8 4.2-.8M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M12 4.1l-6.8 4v7.8L7.1 17V9.2L12 6.4l4.9 2.8V17l1.9-1.1V8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M13 17l-1 .6-1-.5V9.2l-1.9 1.1v7.9l2.9 1.7 2.9-1.7v-7.9L13 9.2z"
  }));
}

module.exports = React.memo(SvgMagento);